import { Paper, styled } from '@mui/material'
import React from 'react'

const StyledPaper = styled(Paper)({
  width: '100%',
  backgroundColor: 'transparent',
  boxShadow: 'none',
})

interface ITabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

const TabPanel: React.FC<ITabPanelProps> = ({ children, value, index }) => {
  return (
    <StyledPaper
      role="tabpanel"
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      hidden={value !== index}
    >
      {children}
    </StyledPaper>
  )
}

export default TabPanel
